import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GetCollaboratorOutput } from '../domain/dtos/get-collaborator-output'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class GetCollaborator {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(collaboratorUserId: string): Promise<GetCollaboratorOutput> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_WEB_URL}/user/roleplay/collaborators/${collaboratorUserId}`,
    })

    if (response.statusCode === HttpStatusCode.OK) {
      return response.data
    }

    throw new GeneralError()
  }
}
